import { useTranslation } from "react-i18next";
import { normalizeLanguage } from "../../utils/language";

const StoreBadges = () => {
  const { i18n } = useTranslation();
  const language = normalizeLanguage(i18n.language);

  const appStoreUrl =
    language === "en"
      ? "https://apps.apple.com/us/app/therapoloji-terapi-hipnoz/id1667121878"
      : "https://apps.apple.com/tr/app/therapoloji-terapi-hipnoz/id1667121878";

  const googlePlayUrl = `https://play.google.com/store/apps/details?id=com.mifosoft.therapoloji&hl=${language}`;

  const appStoreImage = `${process.env.PUBLIC_URL}/${
    language === "en" ? "appstoreEN.png" : "appstore.png"
  }`;

  const googlePlayImage = `${process.env.PUBLIC_URL}/${
    language === "en" ? "googleplayEN.png" : "googleplay.png"
  }`;

  return (
    <div className="hrefImages flex justify-center gap-4">
      <a href={appStoreUrl} className="shadow-custom-4-sided shadow-customWhite rounded">
        <img src={appStoreImage} alt="App Store" className="w-40 rounded" loading="lazy" />
      </a>
      <a href={googlePlayUrl} className="shadow-custom-4-sided shadow-customWhite rounded">
        <img src={googlePlayImage} alt="Google Play" className="w-40 rounded" loading="lazy" />
      </a>
    </div>
  );
};

export default StoreBadges;
